module.exports = __webpack_public_path__ + "img/menu_plaisir.b14f266e.png";